
define('text!SageDotCom/Components/Templates/AppliedFacetSection.html',[],function () { return '<div class="js-funnelback-facet-section applied-facet" data-applied-category-query-string="{{ QueryString }}">\r\n    {{ Name }}<span>: {{ AppliedCategory }}</span>\r\n</div>';});

